import { Trip, TripRef } from "@/types/trip"
import { createAsyncThunk } from "@reduxjs/toolkit"

import { itineraryApi } from "./api/itinerary-api"
import { populateTripCache, tripsApi } from "./api/trips-api"
import type { AppDispatch } from "./redux-store"
import tripSlice, { setLoadingTripRef } from "./trip-slice"

export const initTrip = createAsyncThunk<
  Trip,
  TripRef | Trip,
  { dispatch: AppDispatch }
>("tripThunks/initTrip", async (arg, { dispatch }) => {
  const tripRef = typeof arg === "string" ? arg : arg.ref
  const prefetchedTrip = typeof arg === "string" ? undefined : arg

  dispatch(setLoadingTripRef(tripRef))
  dispatch(tripSlice.actions.setTripRef(tripRef))

  if (prefetchedTrip) {
    void populateTripCache(dispatch, prefetchedTrip)
  }

  const trip = prefetchedTrip
    ? prefetchedTrip
    : await dispatch(tripsApi.endpoints.getTrip.initiate(tripRef)).unwrap()

  if (trip.user_created) {
    void dispatch(itineraryApi.endpoints.getItinerary.initiate({ tripRef }))
  }

  dispatch(setLoadingTripRef(undefined))

  if (trip.collaboration) {
    void dispatch(tripsApi.endpoints.getCollaborators.initiate(tripRef))
  }

  return trip
})
